module.exports = __webpack_public_path__ + "img/STALIZ.svg?6ec4485390473e001e52e169093bfa36";